import React, {createContext, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {FilterContext} from "../../../../components/filters/DashboardFilterContextProvider.jsx";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import {translateReportingError} from "../../../../api/utilities/useReportingError.js";

const LegacyPeriodReportContext = createContext(null);

export function LegacyPeriodReportBoundary({project, reportKey, children}) {
    const filters = useContext(FilterContext);
    const scope = JSON.stringify([project?.id, reportKey, filters.since?.format("YYYY-MM-DD"), filters.until?.format("YYYY-MM-DD"), filters.centresAllowListed, filters.domainsAllowListed, filters.customerWholesaleRequestFilter, filters.sourcesRemoved, filters.campaignsAllowListed, filters.campaignSearchFilter]);
    return <LegacyPeriodReportScope key={scope}>{children}</LegacyPeriodReportScope>;
}

function LegacyPeriodReportScope({children}) {
    const [retentionExpired, setRetentionExpired] = useState(false);
    const active = useRef(true);
    useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
    const onRetentionExpired = useCallback(() => { if (active.current) setRetentionExpired(true); }, []);
    const value = useMemo(() => ({retentionExpired, onRetentionExpired, isActive: () => active.current}), [retentionExpired, onRetentionExpired]);
    return <LegacyPeriodReportContext.Provider value={value}>{children}</LegacyPeriodReportContext.Provider>;
}

export function useLegacyPeriodReportState() {
    return useContext(LegacyPeriodReportContext);
}

export function useLegacyPeriodReportError() {
    const boundary = useLegacyPeriodReportState();
    const {et: translate} = useErrorTranslation();
    const et = useCallback((error) => boundary ? translateReportingError(error, {
        isActive: boundary.isActive,
        onRetentionExpired: boundary.onRetentionExpired,
        translate,
    }) : translate(error), [boundary, translate]);
    return {et};
}
